import styled from 'styled-components';

interface IProps {
  transparentPercentage?: number;
}

export const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const DropAreaContainer = styled.div`
`;

export const DropArea = styled.div`
  position: absolute;
`

export const TransparentArea = styled.div`
  position: absolute;
  background: ${(props: IProps) => ( props.transparentPercentage !== undefined ?
    `repeating-conic-gradient(#1D1D1D 0% 25%, transparent 0% 50%) 50% / ${20*props.transparentPercentage}px ${20*props.transparentPercentage}px` : `auto`)};
`